const API_BASE_URL = process.env.NODE_ENV === 'production'
  ? '/api'
  : 'http://localhost:3000/api';

export interface ContactFormData {
  name: string;
  email: string;
  company?: string;
  message: string;
}

export interface EmailResponse {
  success: boolean;
  error?: string;
}

export const sendContactForm = async (formData: ContactFormData): Promise<EmailResponse> => {
  try {
    const response = await fetch(`${API_BASE_URL}/send-email`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ formData }),
    });

    const responseData = await response.json().catch(() => ({ error: 'Error de conexión' }));

    if (!response.ok) {
      throw new Error(responseData.error || 'Error al enviar el mensaje');
    }

    return { success: true };
  } catch (error) {
    console.error('Error sending contact form:', error);
    return {
      success: false,
      error: error instanceof Error ? error.message : 'Error desconocido al enviar el mensaje',
    };
  }
};
